import React from 'react';
import { renderIf } from 'modules/render-if';
import Copy from '../copy';
import { Actions } from '../reducer';
import ErrorStates from '../lib/errorStates';
import LineItem from './LineItem';

const topClassName = (isOpen) => {
  const base = 'cart-widget loaded';
  return isOpen ? base : `${base} closedCartWidget`;
};

const loadingOverlay = (
  <div className="loadingOverlay">
    <h2>
      <span>
        Loading <span className="animation-ellipsis"></span>
      </span>
    </h2>
  </div>
);

const errorIcon = (
  <svg width="18px" height="18px" viewBox="14 1 18 18">
    {/* eslint-disable */}
    <g id="Group-40" stroke="none" strokeWidth="1" fill="none" fillRule="evenodd" transform="translate(14.000000, 1.000000)">
      <path d="M9.0459,16.6052813 C4.76574375,16.6052813 1.2834,13.1229375 1.2834,8.84278125 C1.2834,4.562625 4.76574375,1.08028125 9.0459,1.08028125 C13.3260563,1.08028125 16.8084,4.562625 16.8084,8.84278125 C16.8084,13.1229375 13.3260563,16.6052813 9.0459,16.6052813 L9.0459,16.6052813 Z M9.0459,0.21778125 C4.290075,0.21778125 0.4209,4.0873875 0.4209,8.84278125 C0.4209,13.5990375 4.290075,17.4677813 9.0459,17.4677813 C13.801725,17.4677813 17.6709,13.5990375 17.6709,8.84278125 C17.6709,4.0873875 13.801725,0.21778125 9.0459,0.21778125 L9.0459,0.21778125 Z" id="Fill-165" fill="#FFFFFF"></path>
      <path d="M9.0459,10.67775 C8.80785,10.67775 8.61465,10.4849813 8.61465,10.2465 L8.61465,3.66778125 C8.61465,3.42973125 8.80785,3.23653125 9.0459,3.23653125 C9.28395,3.23653125 9.47715,3.42973125 9.47715,3.66778125 L9.47715,10.2465 C9.47715,10.4849813 9.28395,10.67775 9.0459,10.67775" id="Fill-166" fill="#FFFFFF"></path>
      <path d="M9.0459,14.4490313 C8.80785,14.4490313 8.61465,14.2562625 8.61465,14.0177813 L8.61465,12.5278125 C8.61465,12.2897625 8.80785,12.0965625 9.0459,12.0965625 C9.28395,12.0965625 9.47715,12.2897625 9.47715,12.5278125 L9.47715,14.0177813 C9.47715,14.2562625 9.28395,14.4490313 9.0459,14.4490313" id="Fill-167" fill="#FFFFFF"></path>
    </g>
    {/* eslint-enable */}
  </svg>
);

const renderErrorMessage = (errorMessage, errorState, brandName) => {
  return (
    <div className="row-fluid cartError">
      <p>
        <span className="errorIcon">
          {errorIcon}
        </span>
        <span className="errorMessage">
          {renderIf(errorState === ErrorStates.NONE && errorMessage)(() => (
            <span dangerouslySetInnerHTML={{ __html: errorMessage }} />
          ))}
          {renderIf(errorState === ErrorStates.REMOVING)(() => Copy.removeError)}
          {renderIf(errorState === ErrorStates.LOADING)(() => Copy.loadError)}
          {renderIf(errorState === ErrorStates.ADDING)(() => Copy.addError(brandName))}
        </span>
      </p>
    </div>
  );
};

const renderEmptyCart = ({ isLoading, isOpen, errorState, addFailureBrandName, errorMessage }) => {
  return (
    <div className={topClassName(isOpen)}>
      {renderIf(isLoading)(() => loadingOverlay)}
      <div className="row-fluid">
        <div className="span12">
          {renderIf(!errorMessage && errorState === ErrorStates.NONE)(() => (
            <h2>{Copy.emptyCart}</h2>
          ))}
          {renderIf(errorState !== ErrorStates.NONE || errorMessage)(() => (
            renderErrorMessage(errorMessage, errorState, addFailureBrandName)
          ))}
        </div>
      </div>
    </div>
  );
};

const renderLineItems = (lineItems, dispatch) => {
  return lineItems.map((lineItem) => {
    return (
      <LineItem lineItem={lineItem}
        key={lineItem.id}
        onRemoveItem={() => dispatch(Actions.removeLineItemStart(lineItem))}
      />
    );
  });
};

const renderFullCart = ({ model, dispatch }) => {
  const href = model.isUserOverLimit ? null : '/cart';

  const showErrorMessage = model.errorState !== ErrorStates.NONE || model.errorMessage;

  const valueSubtotal = model.lineItems.reduce((total, next) => total + next.costPrice, 0);

  const priceSubtotal = model.lineItems.reduce((total, next) => total + next.price, 0);

  return (
    <div className={topClassName(model.isOpen)}>
      {renderIf(model.isLoading)(() => loadingOverlay)}
      <div className="row-fluid">
        <div className="span12">
          {renderIf(showErrorMessage)(() => renderErrorMessage(
            model.errorMessage,
            model.errorState,
            model.addFailureBrandName))}
          <div className="row-fluid">
            <div className="span12">
              <ul className="unstyled">
                {renderLineItems(model.lineItems, dispatch)}
              </ul>
            </div>
          </div>
        </div>
      </div>
      <div className="row-fluid centered">
        <p dangerouslySetInnerHTML={{ __html: Copy.cartSubtotal(valueSubtotal, priceSubtotal) }}></p>
        <p>
          <span className="guaranteeIcon"></span>
          <span className="guaranteeText">1 Year Money-Back Guarantee</span>
        </p>
      </div>
      <div className="row-fluid">
        <div className="span12">
          <a className="btn btn-primary btn-block"
            href={href}
            disabled={model.errorMessage}
          >
            {Copy.checkoutButton}
          </a>
        </div>
      </div>
    </div>
  );
};

export default ({ model, dispatch }) => {
  if (model.lineItems.length === 0) {
    return renderEmptyCart(model);
  }

  return renderFullCart({ model, dispatch });
};



/** WEBPACK FOOTER **
 ** ./apps/storePages/cartDropdown/components/CartWidget.js
 **/